import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import CharacterCard from "./CharacterCard";

const CharacterCarousel = ({ characters, selectedId, onSelect }) => {
  const [emblaApi, setEmblaApi] = React.useState(null);

  React.useEffect(() => {
    if (!emblaApi || !selectedId) return;
    const index = Math.max(0, characters.findIndex((c) => c.id === selectedId));
    emblaApi.scrollTo(index);
  }, [emblaApi, selectedId, characters]);

  return (
    <div className="relative">
      <Carousel className="w-full" setApi={setEmblaApi} opts={{ align: "center", containScroll: 'trimSnaps' }}>
        <CarouselContent className="py-3 px-3 rounded-3xl border bg-background">
          {characters.map((c) => (
            <CarouselItem key={c.id} className="basis-auto pr-3 sm:pr-4">
              <CharacterCard
                character={c}
                active={selectedId === c.id}
                onClick={() => onSelect(c.id)}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden sm:flex -left-10" />
        <CarouselNext className="hidden sm:flex -right-10" />
      </Carousel>
    </div>
  );
};

export default CharacterCarousel;
